import axios from "axios";
import UserService from "./UserService";

const HttpMethods = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
};

const _axios = axios.create();

// Set the base URL for the axios instance based on user roles
// The internal api url is only availabe within the company network
const resolveApiPrefix = () => {
  if (UserService.hasRole(['Administrator']) || UserService.hasRole(['SD_Medewerker'])) {
    return 'SD_intern';
  }
  return 'SD';
};

const configure = () => {
  _axios.interceptors.request.use((config) => {
    config.baseURL = process.env.REACT_APP_API_URL + resolveApiPrefix();

    if (UserService.isLoggedIn()) {
      const cb = () => {
        config.headers.Authorization = `Bearer ${UserService.getToken()}`;
        return Promise.resolve(config);
      };
      return UserService.updateToken(cb);
    }
    return Promise.resolve(config);
  });
};

const getAxiosClient = () => _axios;

const HttpService = {
  HttpMethods,
  configure,
  getAxiosClient,
};

export default HttpService;